<header class="container">
  <span *ngIf="!isMenuOpen && !showServicesPage" class="burger-icon cup bold-text" (click)="isMenuOpen = true">
    МЕНЮ
  </span>
  <span *ngIf="showServicesPage" class="return-btn cup bold-text" (click)="showServicesPage = false">
    НАЗАД
  </span>
  <span *ngIf="isMenuOpen" class="red-icon size20 cup close-icon" (click)="isMenuOpen = false">
    <svg width="16px" height="16px" viewBox="0 0 16 16">
      <g id="close" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M8,6.87819605 L11.6458628,3.23233321 C11.9556405,2.9225556 12.4578892,2.9225556 12.7676668,3.23233321 C13.0774444,3.54211081 13.0774444,4.04435955 12.7676668,4.35413716 L9.12180395,8 L12.7676668,11.6458628 C13.0774444,11.9556405 13.0774444,12.4578892 12.7676668,12.7676668 C12.4578892,13.0774444 11.9556405,13.0774444 11.6458628,12.7676668 L8,9.12180395 L4.35413716,12.7676668 C4.04435955,13.0774444 3.54211081,13.0774444 3.23233321,12.7676668 C2.9225556,12.4578892 2.9225556,11.9556405 3.23233321,11.6458628 L6.87819605,8 L3.23233321,4.35413716 C2.9225556,4.04435955 2.9225556,3.54211081 3.23233321,3.23233321 C3.54211081,2.9225556 4.04435955,2.9225556 4.35413716,3.23233321 L8,6.87819605 Z" id="Combined-Shape" fill="#1B1D20" fill-rule="nonzero"></path>
      </g>
    </svg>
  </span>
  <nav *ngIf="!showServicesPage" class="menu-list bold-text" [class.open]="isMenuOpen" (click)="isMenuOpen = false">
    <span class="cup" (click)="scrollToSection('about')">О методе</span>
    <span class="cup" (click)="scrollToSection('calculator')">Рассчитать матрицу</span>
    <span class="cup" (click)="scrollToSection('certificate')">Сертификат</span>
    <span class="cup" (click)="scrollToSection('contact')">Контакты</span>
    <button class="prime-btn bold-text services-btn" (click)="showServicesPage = true">Услуги</button>
  </nav>

  <button *ngIf="!showServicesPage" class="prime-btn bold-text services-btn cup" (click)="showServicesPage = true">Услуги</button>
</header>

<!-- Main page -->
<ng-container *ngIf="!showServicesPage">
  <section class="hero">
    <div class="greeting-text container">
      <h1>Приветствую Вас!</h1>
      <p class="bold-text">Меня зовут Светлана, я являюсь сертифицированным консультантом статистического психоанализа и выпускницей школы неНумерологии по методу О.Перцевой</p>
    </div>
    <img src="/assets/hero.jpg" alt="hero">
  </section>

  <section class="about">
    <div class="container">
      <h3 id="about">
        О методе
      </h3>
      <p>Статистический психоанализ - это научный подход в нумерологии, который позволяет по дате рождения составить внутренний "цифровой" портрет любого человека.</p>
      <p>Метод создан моим преподавателем Ольгой Перцевой, на основе квадрата Пифагора. Особенность этого метода в том, что Ольга будучи дипломированным клиническим психотерапевтом использовала матрицу, как основу для своей научной деятельности. В течении 15 лет и по сей день проводятся исследования, сбор статистических данных, не только на основании анализа матриц среднестатистических людей, но и проведена работа по анализу пациентов психиатрических клиник, психоневрологических диспансеров. То есть за этой информацией стоит многолетний научный психотерапевтический труд.</p>
      <p>В процессе анализа Вы узнаете о потенциале своей личности, о сильных и слабых сторонах, я буду освещать для Вас показатели, которые потребуют Вашего внимания и проработки, на пути к комфортной и гармоничной жизни. Вы получите в пользование действенные и простые техники, которые Вы можете использовать ежедневно для улучшения показателей и нейтрализации негативных проявлений.</p>
      <p>Это, своего рода, инструкция о возможностях и потенциале личности, данных человеку от рождения. Я помогу Вам не только найти ответ на вопрос "Почему?", но и "Что делать?".</p>
    </div>
  </section>

  <section class="calculator">
    <div class="container">
      <h3 id="calculator">Расчёт матрицы</h3>
      <app-calculator></app-calculator>
    </div>
  </section>

  <section class="certificate">
    <div class="container">
      <h3 id="certificate">Сертификат</h3>
      <img src="/assets/certificat.jpg" alt=" Сертификат ">
    </div>
  </section>
</ng-container>

<!-- Services page -->
<ng-container *ngIf="showServicesPage">
  <section class="hero hero-services">
    <div class="greeting-text container">
      <h1>Услуги</h1>
      <p class="bold-text">Разбор и анализ вашей матрицы и матриц ваших близких - это научный способ выявить потенциал личности, осветить моменты, требующие внимания и получить техники, которые помогут проработать точки роста и прийти к новой, более качественной жизни!</p>
    </div>
    <img src="/assets/hero-2.jpg" alt="hero">
  </section>

  <section class="services">
    <div class="container">
      <mat-accordion>
        <mat-expansion-panel hideToggle (opened)="foo()">
          <mat-expansion-panel-header>
            <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="add" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path d="M8.79323518,7.20676482 L13.9492639,7.20676482 C14.3873556,7.20676482 14.742499,7.56190831 14.742499,8 C14.742499,8.43809169 14.3873556,8.79323518 13.9492639,8.79323518 L8.79323518,8.79323518 L8.79323518,13.9492639 C8.79323518,14.3873556 8.43809169,14.742499 8,14.742499 C7.56190831,14.742499 7.20676482,14.3873556 7.20676482,13.9492639 L7.20676482,8.79323518 L2.05073614,8.79323518 C1.61264445,8.79323518 1.25750096,8.43809169 1.25750096,8 C1.25750096,7.56190831 1.61264445,7.20676482 2.05073614,7.20676482 L7.20676482,7.20676482 L7.20676482,2.05073614 C7.20676482,1.61264445 7.56190831,1.25750096 8,1.25750096 C8.43809169,1.25750096 8.79323518,1.61264445 8.79323518,2.05073614 L8.79323518,7.20676482 Z" id="Path" fill="#1B1D20" fill-rule="nonzero"></path>
              </g>
            </svg>
            <mat-panel-title>Детальный разбор матрицы</mat-panel-title>
          </mat-expansion-panel-header>
          <ul>
            <li>Полное описание личности по дате рождения в аудио формате (голосовые WhatsApp или файлом Word)</li>
            <li>Обозначения на зоны риска (зависимости, измены, болезни, проблемы с психоэмоциональным состоянием, неуверенность в себе) + техники проработки</li>
            <li>Профессиональная реализация, где и как наилучшим образом раскрыть свой потенциал</li>
            <li>Отвечаю абсолютно на все вопросы в формате онлайн консультации (длительностью около часа)</li>
          </ul>
          <span class="bold-text price">Стоимость: 5000р</span>
          <p><span class="bold-text">Срок выполнения:</span>1-2 дня</p>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="add" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path d="M8.79323518,7.20676482 L13.9492639,7.20676482 C14.3873556,7.20676482 14.742499,7.56190831 14.742499,8 C14.742499,8.43809169 14.3873556,8.79323518 13.9492639,8.79323518 L8.79323518,8.79323518 L8.79323518,13.9492639 C8.79323518,14.3873556 8.43809169,14.742499 8,14.742499 C7.56190831,14.742499 7.20676482,14.3873556 7.20676482,13.9492639 L7.20676482,8.79323518 L2.05073614,8.79323518 C1.61264445,8.79323518 1.25750096,8.43809169 1.25750096,8 C1.25750096,7.56190831 1.61264445,7.20676482 2.05073614,7.20676482 L7.20676482,7.20676482 L7.20676482,2.05073614 C7.20676482,1.61264445 7.56190831,1.25750096 8,1.25750096 C8.43809169,1.25750096 8.79323518,1.61264445 8.79323518,2.05073614 L8.79323518,7.20676482 Z" id="Path" fill="#1B1D20" fill-rule="nonzero"></path>
              </g>
            </svg>
            <mat-panel-title>Детальный разбор детской матрицы</mat-panel-title>
          </mat-expansion-panel-header>
          <ul>
            <li>Полное описание личности по дате рождения (файлом в Word)</li>
            <li>Обозначения на зоны риска в развитии ребенка + проработки</li>
            <li>Спортивная + профессиональная реализация, подберем наиболее подходящий вид спорта из потенциальных способностей, и даже дополнительные кружки и развивашки при необходимости</li>
            <li>Отвечаю абсолютно на все вопросы в формате онлайн консультации (длительностью около часа)</li>
          </ul>
          <span class="bold-text price">Стоимость: 3000р</span>
          <p><span class="bold-text">Срок выполнения:</span>1-2 дня</p>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="add" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path d="M8.79323518,7.20676482 L13.9492639,7.20676482 C14.3873556,7.20676482 14.742499,7.56190831 14.742499,8 C14.742499,8.43809169 14.3873556,8.79323518 13.9492639,8.79323518 L8.79323518,8.79323518 L8.79323518,13.9492639 C8.79323518,14.3873556 8.43809169,14.742499 8,14.742499 C7.56190831,14.742499 7.20676482,14.3873556 7.20676482,13.9492639 L7.20676482,8.79323518 L2.05073614,8.79323518 C1.61264445,8.79323518 1.25750096,8.43809169 1.25750096,8 C1.25750096,7.56190831 1.61264445,7.20676482 2.05073614,7.20676482 L7.20676482,7.20676482 L7.20676482,2.05073614 C7.20676482,1.61264445 7.56190831,1.25750096 8,1.25750096 C8.43809169,1.25750096 8.79323518,1.61264445 8.79323518,2.05073614 L8.79323518,7.20676482 Z" id="Path" fill="#1B1D20" fill-rule="nonzero"></path>
              </g>
            </svg>
            <mat-panel-title>Совместимость</mat-panel-title>
          </mat-expansion-panel-header>
          <ul>
            <li>Разбор взаимодействия секторов ответственности</li>
            <li>Как не допустить ошибку</li>
            <li>Чего не стоит ожидать от партера</li>
            <li>Как не стать жертвой в отношениях</li>
            <li>Могут ли быть измены, и что сделать что бы этого не произошло</li>
            <li>Конфликты в паре и как их решить</li>
          </ul>
          <span class="bold-text price">Стоимость: 3000р</span>
          <p><span class="bold-text">Срок выполнения:</span>1-2 дня</p>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="add" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path d="M8.79323518,7.20676482 L13.9492639,7.20676482 C14.3873556,7.20676482 14.742499,7.56190831 14.742499,8 C14.742499,8.43809169 14.3873556,8.79323518 13.9492639,8.79323518 L8.79323518,8.79323518 L8.79323518,13.9492639 C8.79323518,14.3873556 8.43809169,14.742499 8,14.742499 C7.56190831,14.742499 7.20676482,14.3873556 7.20676482,13.9492639 L7.20676482,8.79323518 L2.05073614,8.79323518 C1.61264445,8.79323518 1.25750096,8.43809169 1.25750096,8 C1.25750096,7.56190831 1.61264445,7.20676482 2.05073614,7.20676482 L7.20676482,7.20676482 L7.20676482,2.05073614 C7.20676482,1.61264445 7.56190831,1.25750096 8,1.25750096 C8.43809169,1.25750096 8.79323518,1.61264445 8.79323518,2.05073614 L8.79323518,7.20676482 Z" id="Path" fill="#1B1D20" fill-rule="nonzero"></path>
              </g>
            </svg>
            <mat-panel-title>Онлайн консультации</mat-panel-title>
          </mat-expansion-panel-header>
          <ul>
            <li>Решение любого интересующего вопроса</li>
            <li>Выбор профессионального вектора</li>
            <li>Проработка секторов</li>
            <li>Определения Альфа/Бета</li>
            <li>Определение таланта ребенка, включая помощь с выбором учебного заведения</li>
          </ul>
          <span class="bold-text price">Стоимость: 1500р</span>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </section>
</ng-container>

<footer>
  <div class="container">
    <h3 id="contact">Контакты:</h3>
    <div class="contacts-wrapper">
      <a href="https://www.instagram.com/svetlanka2211" target="_blank" class="contact-item">
        <img width="30" height="30" src="/assets/inst_logo.png" alt="instagram logo">
      </a>
      <a href="https://wa.me/79257888849" target="_blank" class="contact-item">
        <img width="30" height="30" src="/assets/whatsapp.png" alt="whatsapp logo">
      </a>
      <a href="https://t.me/Svetlana_Tsurenkova" target="_blank" class="contact-item">
        <img width="30" height="30" src="/assets/telegram.png" alt="telegram logo">
      </a>
    </div>

  </div>
</footer>
